export default {
      id: "ic-misc-download-usage",
      viewBox: "0 0 31 31",
      url: "../dist/images/" + "sprite.svg#ic-misc-download-usage",
      toString: function () {
        return this.url;
      }
    }